import React from 'react';

import {type ContextualExpression} from '@packages/utilities/contextual-expression';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import TooltipControl from '@packages/systems/design-system/TooltipControl';
import {StyledHelpIcon} from '@packages/systems/plugins/Effect';
import {VisuallyHidden} from '@packages/systems/spring';
import {LogicLabel} from '@packages/systems/flows/shared';
import {styledDiv} from '@packages/utilities/styled';
import {TypeImplementation} from '@packages/systems/wfdl';

const TooltipContent = styledDiv(({theme: {gutters}}) => ({
  maxWidth: gutters.x4 * 56,
}));

export default function RequestInput({
  label,
  tooltipText,
  dispatch,
  expr,
  required,
}: {
  label: string;
  tooltipText: string;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
  expr: ContextualExpression;
  required: boolean;
}) {
  return (
    <div>
      <LogicLabel label={label} required={required}>
        <VisuallyHidden>{tooltipText}</VisuallyHidden>
        {/* @ts-expect-error - TS2739 - Type '{ "aria-hidden": true; icon: Element; content: Element; alternate: true; }' is missing the following properties from type '{ [x: string]: any; iconStyle?: { padding: number; boxSizing: string; } | undefined; icon?: Element | undefined; cursor?: string | undefined; placement?: string | undefined; children: any; hideOnClick: any; style: any; automationLabel?: string | undefined; }': children, hideOnClick, style */}
        <TooltipControl
          aria-hidden
          icon={<StyledHelpIcon style={{paddingLeft: '4px'}} />}
          content={<TooltipContent>{tooltipText}</TooltipContent>}
          alternate
        />
      </LogicLabel>
      <ExpressionEditor dispatch={dispatch} expression={expr} />
    </div>
  );
}
